// CheckInfoAboutRegistrationKyiv.jsx
import React, { useState } from 'react';
import  apiClient  from '../../../../services/apiClient';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const CheckInfoAboutRegistrationKyiv = () => {
    const [formData, setFormData] = useState({
        doc: '',
        name: '',
        date: '',
        lastName: '',
        secondName: '',
        rnokpp: '',
        dateIssueDoc: '',
        unzrEddr: ''
    });
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState({
        message: '',
        type: null
    });

    const handleInputChange = (field, value) => {
        if(field == "rnokpp") {
            let v = !value ? '' : value && value.match(/^\d+/) || formData.rnokpp;
            if(Array.isArray(v)) v = v[0];
            if(v.length > 10) v = v.slice(0,10);
            return setFormData(prev => ({
                ...prev,
                [field]: v 
            }));
        }

        if(field == "unzrEddr"){
            let v = !value ? '' : value && value.match(/^\d+/) || formData.unzrEddr;
            if(Array.isArray(v)) v = v[0];
            if(v.length > 8) v = v.slice(0,8);
            return setFormData(prev => ({
                ...prev,
                [field]: v 
            }));
        }

        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        // Скидаємо результат при зміні даних
        if (result.message) {
            setResult({ message: '', type: null });
        }
    };

    const getInfo = async () => {
        const { 
            doc, name, date,
            lastName,
            secondName,
            rnokpp,
            dateIssueDoc,
            unzrEddr
         } = formData;

        if (!doc || doc.length < 3) {
            setResult({
                message: 'Невірний формат номеру документа',
                type: 'error'
            });
            return;
        }

        let link = `check_registration_rtgk_kyiv?bcert=${doc}`;

        if (name && name.length > 0) link += `&name=${name}`;
        if (date && date.length > 0) link += `&date=${date}`;
        if (lastName && lastName.length > 0) link += `&last_name=${lastName}`;
        if (secondName && secondName.length > 0) link += `&second_name=${secondName}`;
        if (rnokpp && rnokpp.length > 0) link += `&rnokpp=${rnokpp}`;
        if (dateIssueDoc && dateIssueDoc.length > 0) link += `&date_issuedoc=${dateIssueDoc}`;
        if (unzrEddr && unzrEddr.length > 0) link += `&unzr_eddr=${unzrEddr}`;

        setLoading(true);
        setResult({ message: '', type: null });

        try {
            const response = await apiClient.get(link);
            
            if (response.data && response.data.isRegistered) {
                setResult({
                    message: 'Дитина зареєстрована в Києві',
                    type: 'success'
                });
            } else if (response.data && response.data.statusCode && (response.data.statusCode == 404) ) {
                setResult({
                    message: 'За вказаними параметрами реєстрація не підтверджена',
                    type: 'error'
                });
            } else {
                setResult({
                    message: 'Неочікувана відповідь від сервера',
                    type: 'error'
                });
            }
        } catch (error) {
            console.error('Error:', error);
            setResult({
                message: 'Виникла помилка. Спробуйте пізніше.',
                type: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    const text_help_bcert = "Введіть серію та номер свідоцтва. Для перевірки можливих варіантів запису використовуйте різні комбінації з українських та латинських літер.";
    const text_help_name = "Вкажіть ім'я.";
    const text_help_nameLast = "Вкажіть прізвище.";
    const text_help_nameSecond = "Опціонально можна додати по батькові.";
    const text_help_rnokpp = "Опціонально можна додати РНОКПП.";
    const text_help_eddr = "Опціонально можна додати УНЗР-ЄДДР.";
    const text_help_date = "Вкажіть дату народження.";
    const text_doc_date = "Вкажіть дату видачі свідоцтва про народження";

    return (
        <div>
          {/* Main Content */}
            <div className="container-fluid">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6">
                            <div className="card shadow-sm">


                                <div className="card-body">
                                                                    {/* Name */}
                                <div className="mb-4">
                                    <label htmlFor="name" className="form-label fw-semibold">
                                        Ім’я вихованця *
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        className="form-control"
                                        value={formData.name}
                                        onChange={(e) => handleInputChange('name', e.target.value)}
                                        placeholder="Введіть ім'я дитини"
                                        disabled={loading}
                                    />
                                    <div className="form-text text-muted">
                                        {text_help_name}
                                    </div>
                                </div>
                                
                                {/* lastName */}
                                <div className="mb-4">
                                    <label htmlFor="name" className="form-label fw-semibold">
                                        Прізвище вихованця *
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        className="form-control"
                                        value={formData.lastName}
                                        onChange={(e) => handleInputChange('lastName', e.target.value)}
                                        placeholder="Введіть прізвище вихованця"
                                        disabled={loading}
                                    />
                                    <div className="form-text text-muted">
                                        {text_help_nameLast}
                                    </div>
                                </div>


                                                                {/* lastName */}
                                <div className="mb-4">
                                    <label htmlFor="name" className="form-label fw-semibold">
                                        По батькові
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        className="form-control"
                                        value={formData.secondName}
                                        onChange={(e) => handleInputChange('secondName', e.target.value)}
                                        placeholder="Введіть по батькові"
                                        disabled={loading}
                                    />
                                    <div className="form-text text-muted">
                                        {text_help_nameSecond}
                                    </div>
                                </div>

                                    {/* Document Number */}
                                    <div className="mb-4">
                                        <label htmlFor="doc" className="form-label fw-semibold">
                                           Серія та номер свідоцтва про народження *
                                        </label>
                                        <input
                                            type="text"
                                            id="doc"
                                            className="form-control"
                                            value={formData.doc}
                                            onChange={(e) => handleInputChange('doc', e.target.value)}
                                            placeholder="Введіть серію та номер свідоцтва"
                                            disabled={loading}
                                        />
                                        <div className="form-text text-muted">
                                            {text_help_bcert}
                                        </div>
                                    </div>

                                    

                                    {/* Date */}
                                    <div className="mb-4">
                                        <label htmlFor="date" className="form-label fw-semibold">
                                            Дата народження вихованця
                                        </label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={formData.date}
                                            onChange={(e) => handleInputChange('date', e.target.value)}
                                            placeholder="Введіть дату народження (наприклад, 15.01.2023)"
                                            disabled={loading}
                                        />
                                        <div className="form-text text-muted">
                                            {text_help_date}
                                        </div>
                                    </div>

                                    {/* Date issue document*/}
                                    <div className="mb-4">
                                        <label htmlFor="date" className="form-label fw-semibold">
                                            Дата видачі свідоцтва про народження
                                        </label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={formData.dateIssueDoc}
                                            onChange={(e) => handleInputChange('dateIssueDoc', e.target.value)}
                                            placeholder="Введіть дату видачі свідоцтва про народження (наприклад, 15.01.2023)"
                                            disabled={loading}
                                        />
                                        <div className="form-text text-muted">
                                            {text_doc_date}
                                        </div>
                                    </div>

                                                                        {/* Document Number */}
                                    <div className="mb-4">
                                        <label htmlFor="doc" className="form-label fw-semibold">
                                           РНОКПП
                                        </label>
                                        <input
                                            type="text"
                                            id="rnokpp"
                                            className="form-control"
                                            value={formData.rnokpp}
                                            onChange={(e) => handleInputChange('rnokpp', e.target.value)}
                                            placeholder="Введіть РНОКПП"
                                            disabled={loading}
                                        />
                                        <div className="form-text text-muted">
                                            {text_help_rnokpp}
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <label htmlFor="doc" className="form-label fw-semibold">
                                           УНЗР-ЄДДР
                                        </label>
                                        <input
                                            type="text"
                                            id="doc"
                                            className="form-control"
                                            value={formData.unzrEddr}
                                            onChange={(e) => handleInputChange('unzrEddr', e.target.value)}
                                            placeholder="Введіть УНЗР-ЄДДР"
                                            disabled={loading}
                                        />
                                        <div className="form-text text-muted">
                                            {text_help_eddr}
                                        </div>
                                    </div>


                                    {/* Submit Button */}
                                    <div className="d-grid">
                                        <button 
                                            className="btn btn-primary btn-lg"
                                            onClick={getInfo}
                                            disabled={loading || !formData.doc || !formData.name || !formData.lastName}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Перевірка...
                                                </>
                                            ) : (
                                                'Перевірити реєстрацію'
                                            )}
                                        </button>
                                    </div>

                                    {/* Result */}
                                    {result.message && (
                                        <div className={`alert ${result.type === 'success' ? 'alert-success' : 'alert-danger'} mt-4 mb-0`}>
                                            <div className="d-flex align-items-center">
                                                <FontAwesomeIcon 
                                                    icon={result.type === 'success' ? faCheckCircle : faExclamationTriangle} 
                                                    className="me-2" 
                                                />
                                                <span>{result.message}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Additional Info */}
                            <div className="card mt-4">
                                <div className="card-body">
                                    <h6 className="card-title">Інформація про перевірку</h6>
                                    <p className="card-text small text-muted">
                                        Система перевіряє наявність реєстрації дитини в Реєстрі територіальної громади міста Києва. 
                                        Для точної перевірки рекомендується вказати номер свідоцтва про народження.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckInfoAboutRegistrationKyiv;